import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    
    const { pathname } = useLocation();
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", toggleVisibility);
        return () => {
            window.removeEventListener("scroll", toggleVisibility);
        };
    }, [pathname]);
  
};

export default ScrollToTop;



